export default __webpack_public_path__ + "static/media/P200-Tip-Solution.eb01f176.svg";